// extracted by mini-css-extract-plugin
export default {"name":"_216xS","description":"_2zX1m","values":"nd8c3","label":"hrJaS","value":"J4X5a"};